import { getAssetDomainByMPGlobals } from 'lib/deployment'

export default [
  {
    title: 'Target Sales',
    url: `https://www.target.com/c/clearance/-/N-5q0ga`,
    starCount: '5',
    image: `https://images.cm.digitalturbine.com/static/target_logo.webp`
  },
  {
    title: 'Ulta Sales',
    url: `https://fave.co/3KqaNyk`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/ulta_logo.webp`
  },
  {
    title: 'Bed Bath & Beyond Sales',
    url: `https://fave.co/3LAblCa`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/bed-bath-beyond_logo.webp`
  },
  {
    title: 'Nike Clearence Sales',
    url: `https://fave.co/3NQLO9M`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/nike-logo.webp`
  },
  {
    title: 'Anthropologie Sales',
    url: `https://fave.co/3NQ4K8t`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/anthropologie_logo.webp`
  },
  {
    title: 'The North Face Deals',
    url: `https://fave.co/3udv2ty`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/the_north_face_logo.webp`
  },

  {
    title: 'DSW Clearence',
    url: `https://fave.co/3JsJZwt`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/dsw_logo.webp`
  },
  {
    title: 'Amazon Deals',
    url: `https://www.amazon.com/deals?ref_=nav_cs_gb`,
    starCount: '',
    image: `https://images.cm.digitalturbine.com/static/app-affiliate_deals-amazon_thumb_logo.webp`
  }
]
